import numeral from "numeral";
import { useState } from "react";
import Content from "../components/leasing.c.content";

const FootageDetail = ({ loan }) => {
  const [openDetail, setOpenDetail] = useState(false);

  return (
    <div className="bg-white px-1 ">
      <div className="flex flex-row justify-between p-2">
        <div className="font-bold text-lg text-coolGray-700">รายละเอียด</div>
        {openDetail ? (
          <svg
            onClick={() => setOpenDetail(false)}
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 15l7-7 7 7"
            />
          </svg>
        ) : (
          <svg
            onClick={() => setOpenDetail(true)}
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}
      </div>
      <div
        className={
          "grid grid-cols-1 gap-y-1 pt-0 p-3 bg-white " +
          (openDetail ? "" : "hidden")
        }
      >
        <Content
          label="1. เงินลงทุนไม่รวมภาษีมูลค่าเพิ่ม"
          value={numeral(loan?.initCapital).format("0,0.00")}
        />
        <Content
          label="2. อัตราดอกเบี้ยที่เช่าซื้อเท่ากับอัตราร้อยละ"
          value={numeral(loan?.raw_interest).format("0,0.00")}
        />
        <Content
          label="3. อัตราดอกเบี้ยที่แท้จริง (Effective Interest Rate) เท่ากับอัตราร้อยละ"
          value={numeral(loan?.interest).format("0,0.00")}
        />
        <Content
          label="4. จำนวนงวดที่ผ่อนชำระค่าเช่าซื้อ"
          value={numeral(loan?.period).format("0")}
        />
        <Content
          label="5. รวมจำนวนดอกเบี้ยที่ชำระไม่รวมภาษีมูลค่าเพิ่ม"
          value={numeral(loan?.total_interest_no_vat).format("0,0.00")}
        />
        <Content
          label="6. มูลค่าเช่าซื้อไม่รวมภาษีมูลค่าเพิ่ม"
          value={numeral(loan?.total_amount_no_vat).format("0,0.00")}
        />
        <Content
          label="7. จำนวนเงินค่าเช่าซื้องวดละไม่รวมภาษีมูลค่าเพิ่ม"
          value={numeral(loan?.payPerMonth).format("0,0.00")}
        />
        <Content
          label="8. ค่าภาษีมูลค่าเพิ่ม (7%) สำหรับค่าเช่าซื้อในแต่ละงวด"
          value={numeral(loan?.vat).format("0,0.00")}
        />
        <Content
          label="9. จำนวนเงินค่าเช่าซื้อรวมภาษีมูลค่าเพิ่มงวดละ"
          value={numeral(loan?.vat + loan?.payPerMonth).format("0,0.00")}
        />
        <Content
          label="10. จำนวนเงินค่าเช่าซื้อรวมภาษีมูลค่าเพิ่มทั้งสิ้น"
          value={numeral(loan?.total_amount_in_vat).format("0,0.00")}
        />
      </div>
    </div>
  );
};

export default FootageDetail